import Navigate from './Navigate'

export default Navigate
